module.exports = __webpack_public_path__ + "static/card-img-a19e55cf1988fcc13ddc1abc8a282edb.png";